import React, { useState, useEffect } from 'react';
import { apiConfig, apiGetPage, apiGetCustom } from '../request/api'
import { useSelector, useDispatch } from 'react-redux';
import { imageUrl, zeusApp } from '../request/index'
import '../assets/css/bottom.css'

interface BottomItem {
    bottomString: string;
    bottomStringLeft: string;
    bottomStringRight: string;
    logoImg: string;
}

const EzBottom: React.FC = () => {
    const dispatch = useDispatch();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const logoImage = localStorage.getItem('logoImage')
    const [bottomInfo, setBottomInfo] = useState<BottomItem>({
        bottomString: '',
        bottomStringLeft: '',
        bottomStringRight: '',
        logoImg: '',
    });

    useEffect(() => {
        apiGetCustom({
            pageId: '7A33D4C868F54D968D7E6F0666320BDA',
            languageCode: languageCode,
        }).then(res => {
            const rows = res?.data?.data || [];
            const info: BottomItem = {
                bottomString: rows.find((item: { code: string; }) => item.code === 'downName')?.value || '',
                bottomStringLeft: rows.find((item: { code: string; }) => item.code === 'downLeftName')?.value || '',
                bottomStringRight: rows.find((item: { code: string; }) => item.code === 'downRightName')?.value || '',
                logoImg: rows.find((item: { code: string; }) => item.code === 'bottomLogo')?.value || '',
            };
            setBottomInfo(info);
        });
    }, []);

    return (
        <div className="ezbottom">
            <div className="bottom-header">
                <div className='logo-image'>
                    <img src={`${imageUrl}${logoImage}?zeus-app=${zeusApp}`} />
                </div>
                <div className='bottom-header-right'>{bottomInfo.bottomString}</div>
            </div>
            <div className='ezbottom-bottom'>
                <div className='ezbottom-bottom-left'>{bottomInfo.bottomStringLeft}</div>
                <div className='ezbottom-bottom-right'>{bottomInfo.bottomStringRight}</div>
            </div>
        </div>
    );
};

export default EzBottom;